/** Mirrors C# PaymentData (camelCase JSON). */
export interface PaymentDataInit {
  lookupId: string;
  cardNumber: string;
  cardExpirationMonth: number;
  cardExpirationYear: number;
  cardType: string;
  cardSecurityCode: string;
  billToFirstName: string;
  billToLastName: string;
  billToEmail: string;
  billToAddress1: string;
  billToLocality: string;
  billToAdministrativeArea: string;
  billToPostalCode: string;
  billToCountry: string;
  amount: number;
  currency: string;
  clientReferenceCode?: string;
  emailAddress?: string;
}

export class PaymentData {
  lookupId!: string;
  cardNumber!: string;
  cardExpirationMonth!: number;
  cardExpirationYear!: number;
  cardType!: string;
  cardSecurityCode!: string;
  billToFirstName!: string;
  billToLastName!: string;
  billToEmail!: string;
  billToAddress1!: string;
  billToLocality!: string;
  billToAdministrativeArea!: string;
  billToPostalCode!: string;
  billToCountry!: string;
  amount!: number;
  currency!: string;
  clientReferenceCode?: string;
  emailAddress?: string;

  constructor(init: PaymentDataInit) {
    Object.assign(this, init);
  }
}
